import type { QueryClient } from '@tanstack/react-query'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import type { ReactElement } from 'react'
import { Fusszeile, Kopfzeile } from '../components/Huelle'
import { FarbschemaProvider } from '../theme'

/** Der Router trägt den QueryClient, damit Loader später ohne Prop-Kette an den Cache kommen. */
export interface RouterKontext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterKontext>()({
  component: Wurzel,
})

// Rückgabetyp ist ReactElement, nicht JSX.Element: @types/react 19 kennt keinen globalen
// JSX-Namensraum mehr. Das gilt für jede Komponente dieses Projekts.
function Wurzel(): ReactElement {
  return (
    <FarbschemaProvider>
      {/* Sichtbar erst im Fokus (tokens.css, .sprungmarke): wer tabbt, überspringt damit Kopfzeile
          und Filterleiste; wer mit der Maus arbeitet, sieht die Marke nie. */}
      <a className="sprungmarke" href="#inhalt">
        Zum Inhalt springen
      </a>
      {/* Die Kopfzeile zeigt sich nur mit geladener Sitzung; auf Anmeldung und Einladung bleibt sie
          leer (components/Huelle.tsx). */}
      <Kopfzeile />
      {/* tabIndex={-1}, damit der Sprung den Fokus wirklich mitnimmt: ohne das bewegt sich in den
          meisten Browsern nur die Bildlaufleiste, und die nächste Tabulatortaste stünde wieder oben. */}
      <main id="inhalt" tabIndex={-1}>
        <Outlet />
      </main>
      <Fusszeile />
    </FarbschemaProvider>
  )
}
